import { render, staticRenderFns } from "./BaggageSelling.vue?vue&type=template&id=af036938&scoped=true"
import script from "./BaggageSelling.vue?vue&type=script&lang=js"
export * from "./BaggageSelling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af036938",
  null
  
)

export default component.exports